import { lazy } from 'react';

export const TransferorderPage = lazy(() => import('./page-list'));
